var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "index", attrs: { id: "index" } }, [
    _vm._m(0),
    _c(
      "span",
      { staticClass: "index-download", on: { click: _vm.sloganClick } },
      [
        _vm._v(_vm._s(_vm.slogan)),
        _c("span", { staticClass: "index-download-tip" }, [
          _vm._v(_vm._s(_vm.downloadTip)),
          _c("span", { staticClass: "index-download-right" })
        ])
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showMainPage,
            expression: "showMainPage"
          }
        ],
        staticClass: "index-main"
      },
      [
        _c("div", { staticClass: "index-logo" }, [
          _vm.groupInfo.imgSrc
            ? _c("div", { staticClass: "index-img" }, [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showLogo,
                      expression: "showLogo"
                    }
                  ],
                  staticClass: "index-img",
                  attrs: { src: _vm.groupInfo.imgSrc },
                  on: { load: _vm.loadedGoupLogo, error: _vm.loadedErrorLogo }
                }),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showLogo,
                        expression: "!showLogo"
                      }
                    ],
                    staticClass: "index-font"
                  },
                  [_vm._v(_vm._s(_vm.groupInfo.groupName.substr(0, 1)))]
                )
              ])
            : _vm._e(),
          _c("div", { staticClass: "index-title" }, [
            _vm.groupInfo.groupName
              ? _c("img", { attrs: { src: _vm.groupInfo.groupNameImg } })
              : _vm._e()
          ]),
          _vm.groupInfo.extraInfo
            ? _c("p", {
                staticClass: "index-extrainfo",
                domProps: { innerHTML: _vm._s(_vm.groupInfo.extraInfo) }
              })
            : _vm._e(),
          _vm.groupInfo.descNoInfo
            ? _c("p", {
                staticClass: "index-extrainfo",
                domProps: { innerHTML: _vm._s(_vm.groupInfo.descNoInfo) }
              })
            : _vm._e()
        ]),
        _c(
          "div",
          {
            staticClass: "index-buttons",
            class: { show: _vm.show.iosShow && !_vm.show.maskShow },
            on: { mouseover: _vm.iosQrHandler, mouseout: _vm.iosQrHandler }
          },
          [
            _vm.ifMobile
              ? _c(
                  "a",
                  {
                    staticClass: "index-btn",
                    attrs: { href: "javascript:;" },
                    on: { click: _vm.joinGroup }
                  },
                  [_vm._v(_vm._s(_vm.btnText))]
                )
              : _vm._e(),
            !_vm.ifMobile
              ? _c(
                  "div",
                  {
                    staticClass: "qrcode-ios",
                    class: {
                      "qrcode-ios-show": _vm.show.iosQrShow && !_vm.ifMobile
                    }
                  },
                  [
                    _c("qr-code", {
                      staticClass: "qrcode-img",
                      attrs: { val: _vm.qrCodeVal, size: _vm.qrCodeSize }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        ),
        _c(
          "div",
          {
            staticClass: "index-buttons",
            class: { show: _vm.show.androidShow && !_vm.show.maskShow },
            on: {
              mouseover: function($event) {
                _vm.show.androidQrShow = true
              },
              mouseout: function($event) {
                _vm.show.androidQrShow = false
              }
            }
          },
          [
            _c(
              "a",
              {
                staticClass: "index-btn",
                attrs: { href: "javascript:;" },
                on: { click: _vm.downloadAndroidConfirm }
              },
              [_vm._v(_vm._s(_vm.btnText))]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show.androidQrShow && !_vm.ifMobile,
                    expression: "show.androidQrShow && !ifMobile"
                  }
                ],
                staticClass: "qrcode-android"
              },
              [
                _c("qr-code", {
                  staticClass: "qrcode-img",
                  attrs: { val: _vm.qrCodeVal, size: _vm.qrCodeSize }
                })
              ],
              1
            )
          ]
        ),
        _c("div", { staticClass: "index-title" }, [
          _vm.groupInfo.desc
            ? _c("img", {
                staticClass: "index-extrainfo",
                staticStyle: { "margin-top": ".2rem" },
                attrs: { src: _vm.groupInfo.descImg }
              })
            : _vm._e()
        ])
      ]
    ),
    _vm.show.maskShow || _vm.show.maskDownloadAndroid
      ? _c("div", { staticClass: "index-mask" }, [
          _c("div", { staticClass: "load" })
        ])
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "index-alert",
        class: { show: _vm.show.androidAlertShow },
        on: {
          click: function($event) {
            _vm.show.androidAlertShow = false
          }
        }
      },
      [_c("div", { staticClass: "index-arrow" }), _vm._m(1)]
    ),
    _c(
      "div",
      {
        staticClass: "index-alert",
        class: { show: _vm.show.iosAlertShow },
        on: {
          click: function($event) {
            _vm.show.iosAlertShow = false
          }
        }
      },
      [_c("div", { staticClass: "index-arrow" }), _vm._m(2)]
    ),
    _c(
      "div",
      {
        staticClass: "ios-popup",
        class: { "popup-show": _vm.show.iosConfirmShow }
      },
      [
        _c("div", {
          staticClass: "popup-mask",
          on: {
            click: function($event) {
              _vm.show.iosConfirmShow = false
            }
          }
        }),
        _c("div", { staticClass: "popup-box" }, [
          _vm._m(3),
          _c(
            "div",
            { staticClass: "flex-box flex-item-around flex-item-align-center" },
            [
              _c(
                "span",
                {
                  staticClass: "popup-btn",
                  on: {
                    click: function($event) {
                      return _vm.downloadIOS("click")
                    }
                  }
                },
                [_vm._v("知道了")]
              ),
              _c(
                "span",
                {
                  staticClass: "popup-btn",
                  staticStyle: { "background-color": "#c0c0c0" },
                  on: {
                    click: function($event) {
                      _vm.show.iosConfirmShow = false
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ]
          )
        ])
      ]
    ),
    _c(
      "div",
      {
        staticClass: "ios-popup",
        class: { "popup-show": _vm.show.androidConfirmShow }
      },
      [
        _c("div", {
          staticClass: "popup-mask",
          on: {
            click: function($event) {
              _vm.show.androidConfirmShow = false
            }
          }
        }),
        _c("div", { staticClass: "popup-box" }, [
          _c("p", { staticClass: "popup-content" }, [_vm._v(_vm._s(_vm.tips))]),
          _c(
            "div",
            { staticClass: "flex-box flex-item-around flex-item-align-center" },
            [
              _c(
                "span",
                {
                  staticClass: "popup-btn",
                  on: {
                    click: function($event) {
                      return _vm.downloadAndroidNow("click")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.iKnowBtn))]
              ),
              _c(
                "span",
                {
                  staticClass: "popup-btn",
                  staticStyle: { "background-color": "#c0c0c0" },
                  on: {
                    click: function($event) {
                      _vm.show.androidConfirmShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.cancelBtn))]
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "index-header" }, [
      _c("img", {
        staticClass: "index-icon 2",
        attrs: { src: require("assets/images/logo_new.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "index-alert-main" }, [
      _c("p", { staticClass: "index-info" }, [_vm._v('1、点击右上角 "···"')]),
      _c("p", { staticClass: "index-info" }, [
        _vm._v('2、选择 "在浏览器中打开"')
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "index-alert-main" }, [
      _c("p", { staticClass: "index-info" }, [_vm._v('1、点击右上角 "···"')]),
      _c("p", { staticClass: "index-info" }, [
        _vm._v('2、选择 "在Safari浏览器中打开"')
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "popup-content" }, [
      _vm._v("点击安装后APP会自动下载，"),
      _c("br"),
      _vm._v("请返回桌面查看。")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2a183b29", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2a183b29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./pages/index.vue
// module id = 4Z11
// module chunks = 2